import React from 'react'

const IconProducts1 = ({ width = 32, height = 32 }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    fill='none'
    version='1.1'
    width={width}
    height={height}
    viewBox='0 0 32 32'
  >
    <defs>
      <clipPath id='master_svg0_70_5767'>
        <rect x='0' y='0' width='32' height='32' rx='0' />
      </clipPath>
      <linearGradient
        x1='0.7736498117446899'
        y1='0.22006623446941376'
        x2='0.17680026590824133'
        y2='0.8126061558723451'
        id='master_svg1_1_0125'
      >
        <stop offset='0%' stopColor='#FFFFFF' stopOpacity='0' />
        <stop offset='85.87130308151245%' stopColor='#FFFFFF' stopOpacity='1' />
      </linearGradient>
    </defs>
    <g clipPath='url(#master_svg0_70_5767)'>
      <g>
        <rect x='0' y='0' width='32' height='32' rx='2.133333444595337' fill='#252A3A' fillOpacity='1' />
      </g>
      <g>
        <g transform='matrix(0.7005311250686646,-0.7136217951774597,0.7005311250686646,0.7136217951774597,-12.344997928182693,10.397343532562786)'>
          <path
            d='M7.64294057220459,20.66860587677002C7.07980157220459,20.527999876770018,6.56981957220459,21.03804587677002,6.71049557220459,21.60116587677002L8.95140057220459,30.57146587677002C9.02026057220459,30.847065876770017,9.235520572204589,31.06236587677002,9.51120057220459,31.13116587677002L18.48050057220459,33.37116587677002C19.04360057220459,33.51176587677002,19.55360057220459,33.00186587677002,19.413000572204588,32.43876587677002L17.17400057220459,23.468475876770018C17.105200572204588,23.19271587677002,16.88990057220459,22.97740587677002,16.614200572204588,22.90855587677002L7.64294057220459,20.66860587677002Z'
            fill='url(#master_svg1_1_0125)'
            fillOpacity='1'
          />
        </g>
        <g transform='matrix(0.7005311250686646,-0.7136217951774597,0.7005311250686646,0.7136217951774597,-9.78076149892263,9.349079723756176)'>
          <path
            d='M7.64294057220459,17.008188320007324C7.07980157220459,16.867582320007322,6.56981957220459,17.377628320007325,6.71049557220459,17.940748320007323L8.95140057220459,26.911048320007325C9.02026057220459,27.186648320007322,9.235520572204589,27.401948320007325,9.51120057220459,27.470748320007324L18.48050057220459,29.710748320007326C19.04360057220459,29.851348320007325,19.55360057220459,29.341448320007324,19.413000572204588,28.778348320007325L17.17400057220459,19.808058320007323C17.105200572204588,19.532298320007325,16.88990057220459,19.316988320007326,16.614200572204588,19.248138320007325L7.64294057220459,17.008188320007324ZM9.72304057220459,26.699148320007325L7.49913057220459,17.796838320007325L16.402300572204588,20.019808320007325L18.62440057220459,28.922048320007324L9.72304057220459,26.699148320007325Z'
            fillRule='evenodd'
            fill='#FFFFFF'
            fillOpacity='1'
          />
        </g>
        <g transform='matrix(0.7005311250686646,-0.7136217951774597,0.7005311250686646,0.7136217951774597,-6.6123175087536765,8.053814931779357)'>
          <path
            d='M7.64294057220459,12.485271526184082C7.07980157220459,12.344665526184082,6.56981957220459,12.854711526184083,6.71049557220459,13.417831526184083L8.95140057220459,22.388131526184083C9.02026057220459,22.66373152618408,9.235520572204589,22.879031526184082,9.51120057220459,22.947831526184082L18.48050057220459,25.187831526184084C19.04360057220459,25.328431526184083,19.55360057220459,24.81853152618408,19.413000572204588,24.255431526184083L17.17400057220459,15.285141526184082C17.105200572204588,15.009381526184082,16.88990057220459,14.794071526184082,16.614200572204588,14.725221526184082L7.64294057220459,12.485271526184082ZM9.72304057220459,22.176231526184083L7.49913057220459,13.273921526184083L16.402300572204588,15.496891526184083L18.62440057220459,24.39913152618408L9.72304057220459,22.176231526184083Z'
            fillRule='evenodd'
            fill='#FFFFFF'
            fillOpacity='1'
          />
        </g>
      </g>
    </g>
  </svg>
)

export default IconProducts1
